import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import UsePagination from '../../../../../components/pagination'
import MyQuizTemplate from './MyQuizTemplate'
import { Icon } from '../../../../../components/UI'

import { selectRole } from '../../../../../routing/fetchingfunction/user/user.reducer'
import {
  selectLoadingQuizzes,
  selectQuizzesPagination,
} from '../../../../../routing/fetchingfunction/quiz/quiz.reducer'
import { getQuizzes } from '../../../../../routing/fetchingfunction/quiz/quiz.actions'

import { getPaginationTotalLength } from '../../../../../helpers'

const MyQuizTemplatesList = ({ passedCategories }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const role = useSelector(selectRole)
  const { quizzes, quizzesPage, quizzesPageSize, quizzesTotal } =
    useSelector(selectQuizzesPagination)
  const loading = useSelector(selectLoadingQuizzes)

  const hasAvailableCategory = !!passedCategories.length

  const handleAdd = () => {
    if (!hasAvailableCategory) {
      return
    }

    navigate(`/${role}/settings/my-quiz-templates/add`)
  }

  const handlePageChange = (_, value) => {
    if (value !== quizzesPage) {
      dispatch(
        getQuizzes({
          page: value,
        })
      )
    }
  }

  useEffect(() => {
    if (!loading) {
      dispatch(
        getQuizzes({
          page: quizzesPage || 1,
        })
      )
    }
  }, [])

  const quizzesContent =
    quizzes.length &&
    quizzes.map((quizz) => {
      return <MyQuizTemplate key={quizz.id} quizTemplate={quizz} />
    })

  return (
    <div className="w-full bg-[#FEEBDD] rounded-[10px] p-[32px] mt-[20px]">
      <div className="w-full flex items-center justify-between">
        <h5 className="text-base font-bold text-primary-100">Quiz Template</h5>

        <button
          disabled={!hasAvailableCategory}
          className={`px-[16px] h-[40px] shadow-button bg-primary-button rounded-[8px] flex items-center transition-all duration-200 ease ${hasAvailableCategory ? 'hover:bg-primary-button-hover opacity-100' : 'opacity-70'}`}
          onClick={handleAdd}
        >
          <Icon name="plus" color="#ffffff" className="mr-[8px] w-[24px] h-[24px]" />

          <span className="text-sm font-semibold text-white">Add New Template</span>
        </button>
      </div>

      {!!quizzes.length && (
        <div className="mt-[20px] flex flex-col w-full items-start gap-y-[32px]">
          {quizzesContent}
        </div>
      )}

      {quizzesTotal > quizzesPageSize && (
        <div className="mt-[20px]">
          <UsePagination
            count={getPaginationTotalLength(quizzesTotal, quizzesPageSize)}
            page={quizzesPage}
            onChange={handlePageChange}
            loading={loading}
            altColors
          />
        </div>
      )}
    </div>
  )
}

export default MyQuizTemplatesList
